export const gemData = {
    theWarWithin: {
        elusiveBlasphemite: [213744, 213745, 213746],
        amber: [
            213501, // Deadly Amber+
            213502, // Deadly Amber++
            213503, // Deadly Amber+++
            213507, // Masterful Amber+
            213508, // Masterful Amber++
            213509, // Masterful Amber+++
            213504, // Quick Amber+
            213505, // Quick Amber++
            213506, // Quick Amber+++
            213515, // Solid Amber+
            213516, // Solid Amber++
            213517, // Solid Amber+++
            213510, // Versatile Amber+
            213511, // Versatile Amber++
            213512, // Versatile Amber+++
        ],
        emerald: [
            213477, // Deadly Emerald+
            213478, // Deadly Emerald++
            213479, // Deadly Emerald+++
            213480, // Masterful Emerald+
            213481, // Masterful Emerald++
            213482, // Masterful Emerald+++
            213486, // Quick Emerald+
            213487, // Quick Emerald++
            213488, // Quick Emerald+++
            213483, // Versatile Emerald+
            213484, // Versatile Emerald++
            213485, // Versatile Emerald+++
        ],
        onyx: [
            213489, // Deadly Onyx+
            213490, // Deadly Onyx++
            213491, // Deadly Onyx+++
            213498, // Masterful Onyx+
            213499, // Masterful Onyx++
            213500, // Masterful Onyx+++
            213492, // Quick Onyx+
            213493, // Quick Onyx++
            213494, // Quick Onyx+++
            213495, // Versatile Onyx+
            213496, // Versatile Onyx++
            213497, // Versatile Onyx+++
        ],
        ruby: [
            213462, // Deadly Ruby+
            213463, // Deadly Ruby++
            213464, // Deadly Ruby+++
            213456, // Masterful Ruby+
            213457, // Masterful Ruby++
            213458, // Masterful Ruby+++
            213453, // Quick Ruby+
            213454, // Quick Ruby++
            213455, // Quick Ruby+++
            213459, // Versatile Ruby+
            213460, // Versatile Ruby++
            213461, // Versatile Ruby+++
        ],
        sapphire: [
            213465, // Deadly Sapphire+
            213466, // Deadly Sapphire++
            213467, // Deadly Sapphire+++
            213471, // Masterful Sapphire+
            213472, // Masterful Sapphire++
            213473, // Masterful Sapphire+++
            213468, // Quick Sapphire+
            213469, // Quick Sapphire++
            213470, // Quick Sapphire+++
            213474, // Versatile Sapphire+
            213475, // Versatile Sapphire++
            213476, // Versatile Sapphire+++
        ],
    },
};
